<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />

    <!-- Container geral com a mesma aparência física de card elevado -->
    <div class="tabela-mandatos" v-if="membros && membros.length !== 0">
      <div class="tabela-mandatos__scroll">
        <table class="table">
          <colgroup>
            <col class="col-cpf" />
            <col class="col-servidor" />
            <col class="col-nome" />
          </colgroup>
          <thead>
            <tr>
              <th class="th-cpf">CPF</th>
              <th class="th-servidor">Servidor Público</th>
              <th class="th-nome">Nome</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(membro, index) in membros">
              <template>
                <tr :key="membro.id" :class="[classesDeEstilo[index], 'linha-clicavel']" @click="irParaDetalhes(membro.id)">
                  <td data-label="CPF:" class="td-cpf">
                    <span>{{ formatarCPF(membro.cpf) }}</span>
                  </td>
                  <td data-label="Servidor Público:" class="td-servidor">
                    <!-- Badge dinâmico: verde para Sim (Servidor), vermelho para Não (Não Servidor) -->
                    <span 
                      class="status-badge" 
                      :class="membro.servidor_publico ? 'status-badge--ativo' : 'status-badge--inativo'"
                    >
                      {{ membro.servidor_publico ? 'Sim' : 'Não' }}
                    </span>

                  </td>
                  <td data-label="Nome:" class="td-nome">
                    <span>{{ formatarNomeProprio(membro.nome) }}</span>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Estado de tabela vazia padronizado -->
    <div class="tabela-mandatos tabela-mandatos--vazia" v-else>
      <p class="sem-resultados">Nenhum Resultado Encontrado</p>
    </div>
  </div>
</template>

<script>
import { parseISO, format } from "date-fns";
import MsgErroFormularios from "../MsgErroFormularios";
import MembroApi from "../../services/MembroApi";

export default {
  name: "TabelaResultadosMembro",
  props: {
    membros: Array,
  },
  components: {
    MsgErroFormularios,
  },
  created() {
    this.membroApi = new MembroApi();
  },
  data() {
    return {
      msgErros: {
        membro: "",
      },
      erro: false,
    };
  },
  computed: {
    classesDeEstilo() {
      if (!this.membros || this.membros.length === 0) return [];
      return this.membros.map((_, index) => {
        return index % 2 === 0 ? 'linha-cinza' : '';
      });
    }
  },
  methods: {
    irParaDetalhes(id) {
      this.$router.push({ name: 'MembroShow', params: { id: id } });
    },
    formatarNomeProprio(texto) {
      if (!texto) return '';
      const excecoes = [
        'de', 'da', 'do', 'di', 'du', 'das', 'dos', 'e', 
        'em', 'na', 'no', 'nas', 'nos', 
        'por', 'pelo', 'pela', 'pelos', 'pelas',
        'com', 'para'
      ];
      const siglasConhecidas = [
        'AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 
        'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
      ];
      return texto
        .toString()
        .toLowerCase()
        .split(' ')
        .map(palavra => {
          const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
          
          if (siglasConhecidas.includes(palavraLimpa)) {
            return palavra.toUpperCase();
          }
          
          if (excecoes.includes(palavra)) {
            return palavra;
          }
          
          return palavra.charAt(0).toUpperCase() + palavra.slice(1);
        })
        .join(' ');
    },
    opcoesExcluir(membroId) {
      let modalExclusao = document.getElementsByClassName("modal-exclusao");
      
      for (let i = 0; i < modalExclusao.length; i++) {
        if (modalExclusao[i].id == membroId) {
          if (modalExclusao[i].style.visibility !== "visible") {
            modalExclusao[i].style.visibility = "visible";
          } else {
            modalExclusao[i].style.visibility = "hidden";
          }
        }
      }
    },
    async excluirLinha(membroId) {
      this.opcoesExcluir(membroId);
      
      try {
        this.carregando = true;
        this.erro = false;
        
        if (this.membroApi.cancelTokens.destroyMembro) {
          this.membroApi.cancelTokens.destroyMembro.cancel();
        }
        
        await this.membroApi.destroyMembro(membroId);
        window.location.reload();
      } catch (err) {
        if (this.membroApi.isCancel(err)) {
          return;
        }
        
        this.carregando = false;
        this.erro = true;
        
        this.msgErros.membro = "Não foi possível excluir o membro. Pois ele está associado a um mandato.";
      }
    },
    fecharErro() {
      this.erro = false;
    },
    formatarData: function (value) {
      if (value == null) {
        return;
      }
      return format(parseISO(value), "dd/MM/yyyy");
    },
    formatarDataParaComparacao(value) {
      let newValue = new Date(value);
      let timeToCompare = newValue.getTime();
      return timeToCompare;
    },
    formatarCPF(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

/* -------------------------------------------------------------------------- */
/* Tabela de mandatos — Identidade visual SITRA                               */
/* -------------------------------------------------------------------------- */
.tabela-mandatos {
  margin-top: 1.35rem;
  background: #ffffff;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

.tabela-mandatos--vazia {
  padding: 1.75rem 1rem;
  text-align: center;
  overflow: hidden;
  
  .sem-resultados {
    margin: 0;
    color: #5f6f66;
    font-family: "Karla", sans-serif;
    font-size: 0.95rem;
  }
}

.tabela-mandatos__scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 0.85rem;
}

.tabela-mandatos .table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  table-layout: fixed;
}

/* Definição de larguras para as 3 colunas */
.tabela-mandatos .col-cpf { width: 25%; }
.tabela-mandatos .col-servidor { width: 25%; }
.tabela-mandatos .col-nome { width: 50%; }

/* Estilos de Célula e Cabeçalho */
.tabela-mandatos .table th,
.tabela-mandatos .table td {
  border: none !important;
  border-bottom: 1px solid #e7eee9 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem; /* Ajustado para 0.95rem */
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

/* Alinhamentos específicos de célula */
.tabela-mandatos .table .th-servidor,
.tabela-mandatos .table .td-servidor {
  text-align: center;
}

/* Alinhando CPF e Nome para a esquerda */
.tabela-mandatos .table .th-cpf,
.tabela-mandatos .table .td-cpf,
.tabela-mandatos .table .th-nome,
.tabela-mandatos .table .td-nome {
  text-align: left;
}
s

.tabela-mandatos .table .th-nome,
.tabela-mandatos .table .td-nome {
  text-align: left;
}

/* Estilização do cabeçalho com novo padrão de divisórias verticais */
.tabela-mandatos .table thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem; /* Ajustado para 0.95rem */
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  
  /* Linha divisória vertical com a cor institucional solicitada */
  border-right: 1px solid #a6c9b1 !important;
  
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
}

/* Remove a borda direita do último th para impedir borda órfã na ponta direita */
.tabela-mandatos .table thead th:last-child {
  border-right: none !important;
}

/* Efeito Zebrado integrando a classe linha-cinza à paleta institucional */
.tabela-mandatos .table tbody tr {
  transition: background-color 0.15s ease;
  background-color: #ededed; // Define a cor padrão das linhas como #ededed (2ª, 4ª, etc.)
}

/* Primeira linha, terceira linha e assim por diante (que recebem a classe .linha-cinza) ficam brancas */
.tabela-mandatos .table tbody tr.linha-cinza {
  background: #ffffff !important;
}

/* Linha Clicável & Hover com a paleta Verde Institucional */
.linha-clicavel {
  cursor: pointer;
}

.tabela-mandatos .table tbody tr.linha-clicavel:hover {
  background: rgba(0, 85, 22, 0.05) !important;
}

/* Estilização do CPF na célula */
.td-cpf {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

/* -------------------------------------------------------------------------- */
/* Badges de Status (Sim/Não)                                                 */
/* -------------------------------------------------------------------------- */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-family: "Karla", sans-serif;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
}

.status-badge--ativo {
  background: rgba(0, 85, 22, 0.12);
  color: #005516;
}

/* Nova cor vermelha institucional para o "Não" */
.status-badge--inativo {
  background: rgba(180, 40, 40, 0.1);
  color: #9b2c2c;
}

.status-badge--neutro {
  background: #eef1ef;
  color: #5f6f66;
}


/* Responsividade Mobile */
@media screen and (max-width: "768px") {
  .tabela-mandatos .table {
    min-width: 600px;
  }
}
</style>
